<template lang="html">
  <div class="add-comment">
    <commentAdd />
  </div>
</template>

<script>
import commentAdd from '@/components/common/comment/add'

export default {
  created() {
    this.$$ensureLogin()
    this.$$title('发表评论')
    this.$$loading(false)
    window && window.kwapp && window.kwapp.allowRefreshOrShare(false, false)
  },
  components: {
    commentAdd
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.add-comment {
  height: 100%;
  margin-top: rem(21px);
  background-color: #fff;
}
</style>
